import mixpanel from "mixpanel-browser";

export function track(event: string, props: Record<string, any> = {}) {
  mixpanel.track(event, {
    ...props,
    ts: Date.now(),
  });
}
